import { useFetchUserBalance } from '@/features/wallet/api'
import { routes } from '@/pages'
import { Spinner } from '@/ui-kit'
import { formatNumber } from '@/utils'
import { Trans } from '@lingui/react/macro'

export const ActivityStats = () => {
  const { data } = useFetchUserBalance()

  if (!data) {
    return (
      <div className="rounded-2xl border border-solid border-gray-100 p-6">
        <div className="flex h-24 items-center justify-center">
          <Spinner size="small" />
        </div>
      </div>
    )
  }

  return (
    <div className="mt-3 flex flex-col gap-4">
      <a className="group flex flex-col border-b border-solid border-gray-100 pb-4" href={routes.wallet.path}>
        <div className="text-gray-90">
          <Trans>Available to Withdraw</Trans>
        </div>
        <div className="text-h2 text-orange group-hover:underline">${formatNumber(data.availableUsd, 2)}</div>
      </a>
      <div className="flex flex-col border-b border-solid border-gray-100 pb-4">
        <div className="text-gray-90">
          <Trans>Under review</Trans>
        </div>
        <div className="text-h4">${formatNumber(data.pendingUsd, 2)}</div>
      </div>
      <div className="flex flex-col border-b border-solid border-gray-100 pb-4">
        <div className="text-gray-90">
          <Trans>Total earned</Trans>
        </div>
        <div className="">${formatNumber(data.totalEarnedUsd, 2)}</div>
      </div>
    </div>
  )
}
